import React, { Fragment } from 'react';
import { FormikContextType, useFormikContext } from 'formik';

export interface IFormRenderProps<T extends Record<string, unknown>> {
  children(formik: FormikContextType<T>): React.ReactNode;
}

export function FormRender<T extends Record<string, unknown>>({
  children,
}: IFormRenderProps<T>) {
  const formik = useFormikContext<T>();

  return <Fragment>{children(formik)}</Fragment>;
}
